import { Typography, withStyles } from '@material-ui/core';
import { hasModuleAccess } from '../../utils/helpers';
import TextLink from '../TextLink/TextLink';
import TitleHeader from '../TitleHeader/TitleHeader';
import SwitchLabel from './SwitchLabel';

const labelColumn = '12rem';

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '0 2rem',
    },
    parserRow: {
        marginTop: '0.5rem',
        '& .MuiFormControlLabel-label': {
            width: labelColumn,
        },
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        marginTop: '1.5rem',
    },
    rowLabel: {
        width: labelColumn,
        fontSize: '0.9rem',
        lineHeight: 1.5,
        color: '#595652',
    },
    clearLink: {
        margin: '0 0 0 0.75rem',
        paddingBottom: 0,
        fontSize: '0.9rem',
        lineHeight: 1.5,
    },
};

const Settings = ({ classes }) => {
    const clearBrowserData = () => {
        localStorage.clear();
        sessionStorage.clear();
        window.location.reload();
    };

    return (
        <div>
            <TitleHeader title={'Ustawienia'} />
            <section className={classes.container}>
                {hasModuleAccess('parsing') && (
                    <div className={classes.parserRow}>
                        <SwitchLabel />
                    </div>
                )}
                <div className={classes.row}>
                    <Typography className={classes.rowLabel}>Dane użytkownika</Typography>
                    <TextLink description={'Wyczyść'} onClick={clearBrowserData} style={styles.clearLink} />
                </div>
            </section>
        </div>
    );
};

export default withStyles(styles)(Settings);
